export default class ContentsScrollTrigger {
    constructor() {
        this.init();
    }

    init() {
        this.contentsScrollTrigger();
    }

    contentsScrollTrigger() {
        gsap.set(".js-scroll-trigger", {
            opacity: 0,
            y: 40,
            rotation: 5,
        });

        ScrollTrigger.batch(".js-scroll-trigger", {
            onEnter: (batch) =>
                gsap.to(batch, {
                    opacity: 1,
                    y: 0,
                    rotation: 0,
                    stagger: 0.1,
                    overwrite: true,
                }),
            start: "top 70%",
        });

        // ポップアップ出現
        const popupTriggers = document.querySelectorAll(".js-scroll-trigger-popup");
        ScrollTrigger.batch(popupTriggers, {
            onEnter: (batch) =>
                gsap.to(batch, {
                    opacity: 1,
                    scale: 1,
                    stagger: 0.1, // 0.1秒ずつ遅延
                    overwrite: true,
                }),
            start: "top bottom",
        });

        // 初期状態の設定
        gsap.set(popupTriggers, {
            opacity: 0,
            scale: 0.8,
        });

        // 見出し個々に回転して出現アニメーション
        const ttlTxt = document.querySelectorAll(".js-ttl-split");

        ttlTxt.forEach((el) => {
            const textContent = el.textContent;
            const newTextContent = [...textContent].map((char) => `<span>${char}</span>`).join("");
            el.innerHTML = newTextContent;
        });

        const textEffect = document.querySelectorAll(".js-text-effect");
        textEffect.forEach((target) => {
            const spans = target.querySelectorAll("span");
            gsap.to(spans, {
                duration: 0.5,
                autoAlpha: 1,
                rotateY: "0deg",
                stagger: {
                    each: 0.05,
                },
                scrollTrigger: {
                    trigger: target,
                    start: "top 85%",
                },
            });
        });

        const revealElm = document.querySelectorAll(".js-scroll-reveal");

        [...revealElm].forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 70%",
                onEnter: () => {
                    el.classList.add("-reveal");
                },
                once: true,
            });
        });
    }
}
